module.exports = __webpack_public_path__ + "static/media/5232.1ec1cf58.jpg";